import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceToDisplay',
  pure: true
})
export class PriceToDisplayPipe implements PipeTransform {
  transform(value: number, float: number | string = 100): number {
    return value / (typeof float === 'number' ? float : Number(float));
  }
}
